import styled from 'styled-components';
import { GREY_400, PURPLE_500 } from '../../../constants';

export const CellWrapper = styled.div<{ isClickable?: boolean }>`
    display: flex;
    align-items: center;
    height: 100%;
    padding: 0.75rem 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${GREY_400};
    font-size: 0.9375rem;
    font-style: normal;
    font-weight: 300;
    line-height: 1.375rem;
    gap: 1rem;
    cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'default')};
`;

export const ClickableText = styled.span`
    color: ${PURPLE_500};
    cursor: pointer;
    text-decoration: none;
    font-size: 1rem;
    font-weight: 400;
    &:hover {
        text-decoration: underline;
    }
`;
